module.exports = __webpack_public_path__ + "static/media/fiscal.68dbcea9.jpg";